import {Action, createReducer, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import {logout} from '../../+account/auth.actions';
import {Price} from './price.model';
import * as PriceActions from './price.actions';

export const priceFeatureKey = 'stripe_prices';

export interface PriceState extends EntityState<Price> {
  // additional entities state properties
  selectedPriceID: string | null;
}

export interface PartialPriceState {
  readonly [priceFeatureKey]: PriceState;
}

export const priceAdapter: EntityAdapter<Price> = createEntityAdapter<Price>();

export const initialPriceState: PriceState = priceAdapter.getInitialState({
  // additional entity state properties
  selectedPriceID: null
});

export const reducer = createReducer(
  initialPriceState,
  on(PriceActions.addPrice, (state, action) =>
    priceAdapter.addOne(action.price, state)
  ),
  on(PriceActions.setPrice, (state, action) =>
    priceAdapter.setOne(action.price, state)
  ),
  on(PriceActions.addPrices, (state, action) =>
    priceAdapter.addMany(action.prices, state)
  ),
  on(PriceActions.updatePrice, (state, action) =>
    priceAdapter.updateOne(action.price, state)
  ),
  on(PriceActions.updatePrices, (state, action) =>
    priceAdapter.updateMany(action.prices, state)
  ),
  on(PriceActions.upsertPrice, (state, action) =>
    priceAdapter.upsertOne(action.price, state)
  ),
  on(PriceActions.upsertPrices, (state, action) =>
    priceAdapter.upsertMany(action.prices, state)
  ),
  on(PriceActions.mapPrice, (state, {entityMap}) => {
    return priceAdapter.mapOne(entityMap, state);
  }),
  on(PriceActions.mapPrices, (state, {entityMap}) => {
    return priceAdapter.map(entityMap, state);
  }),
  on(PriceActions.deletePrice, (state, action) =>
    priceAdapter.removeOne(action.id, state)
  ),
  on(PriceActions.deletePrices, (state, action) =>
    priceAdapter.removeMany(action.ids, state)
  ),
  on(PriceActions.loadPrices, (state, action) => {
    return priceAdapter.setAll(action.prices, priceAdapter.removeAll(state));
  }),
  on(PriceActions.setPrices, (state, action) =>
    priceAdapter.setMany(action.prices, state)
  ),
  on(PriceActions.clearPrices, state => priceAdapter.removeAll(state)),
  // on(logout, state => ({
  //   ...initialPriceState,
  //   ...priceAdapter.removeAll(state)
  // })),
  on(PriceActions.selectPriceID, (state, action) => {
    return {
      ...state,
      selectedPriceID: action.id
    };
  })
);
